var Range = function(start, end) {
    this.start = start,
    this.end = end
}

Range.prototype.intersects = function(range2) {
    return (range2.end >= this.start && range2.start <= this.start) || 
            (range2.start <= this.end && range2.end >= this.end) || 
            (range2.start <= this.start && range2.end >= this.end) ||
            (range2.start > this.start && range2.end < this.end);
}

Range.prototype.equals = function(range2) {
    return (this.start == range2.start && this.end == range2.end);
}

Range.prototype.combine = function(range2) {
    return new Range(Math.min(this.start, range2.start), Math.max(this.end, range2.end));
}


Range.combineArray = function(ranges) {
    if(ranges.length == 0)
        return [];

    var resultRanges = [ranges[0]];
    for(var j=1; j < ranges.length; j++) {
        var newRange = true;
        for(var k=0; k < resultRanges.length; k++) {
            if(ranges[j].equals(resultRanges[k])) {
                newRange = false;
                break;
            }

            if(ranges[j].intersects(resultRanges[k])) {
                ranges[j] = ranges[j].combine(resultRanges[k]);
                resultRanges.splice(k, 1);
                resultRanges.push(ranges[j]);
                
                for(var l=0; l < resultRanges.length; l++) {
                    if(l == k) continue;
                    if(resultRanges[l].intersects(resultRanges[k])) {
                        resultRanges[k] = resultRanges[k].combine(resultRanges[l]);
                        resultRanges.splice(l--, 1);
                    }
                }
                newRange = false;
                break;
            }
        }
        if(newRange)
            resultRanges.push(ranges[j]);
    }
    return resultRanges;
}

Range.sortArray = function(ranges) {
    ranges.sort(function(a, b) {
        if(a.start > b.start)
            return 1;
        if(a.start < b.start)
            return -1;
        return 0;
    });
}